import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/alipay': {
    width: 448,
    height: 512,
    paths: [
      {
        d: 'M377.7 32c38.7 0 70.1 31.6 69.9 70.3v234.4c-48.6-16.7-99.7-36-148.6-52.7 23.1-44.3 38.4-90.9 38.4-90.9h-88.8v-31.2h109.5v-19h-109.4v-50.4h-50.9v50.4h-109.4v19h109.4v31.2h-92.1v16.7h178.2s-9.9 30.3-26.5 60.3c-47.8-14.7-91.8-25-127.1-25-84.6 0-103.5 42.5-99.5 81.5 3.3 31.1 26.5 76.4 97 76.4 64.5 0 116.5-37 148.6-81 61 28.1 125.6 62.8 171.6 88.4-0.5 38.5-31.7 69.6-70.3 69.6h-307.5c-38.8 0-70.3-31.4-70.3-70.3v-307.5c0-38.8 31.4-70.3 70.3-70.3h307.5zM47.3 322.9c-1-17.5 10.9-50.6 78.4-50.6 25 0 64.8 12.7 109.4 31.4-25.3 33.2-65.8 72.9-117.9 72.9-59.7 0-68.9-33.6-69.9-53.7z'
      }
    ]
  }
})
